/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationStoreInAppAppStoreAppStoreInAppBillingData } from './FxIdApplicationStoreInAppAppStoreAppStoreInAppBillingData';
import {
    instanceOfFxIdApplicationStoreInAppAppStoreAppStoreInAppBillingData,
    FxIdApplicationStoreInAppAppStoreAppStoreInAppBillingDataFromJSON,
    FxIdApplicationStoreInAppAppStoreAppStoreInAppBillingDataFromJSONTyped,
    FxIdApplicationStoreInAppAppStoreAppStoreInAppBillingDataToJSON,
} from './FxIdApplicationStoreInAppAppStoreAppStoreInAppBillingData';

/**
 * @type FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingData
 * 
 * @export
 */
export type FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingData = FxIdApplicationStoreInAppAppStoreAppStoreInAppBillingData;

export function FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingDataFromJSON(json: any): FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingData {
    return FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingDataFromJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingData {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreInAppAppStoreAppStoreInAppBillingData(json)) {
        return FxIdApplicationStoreInAppAppStoreAppStoreInAppBillingDataFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingDataToJSON(json: any): any {
    return FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingDataToJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingDataToJSONTyped(value?: FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationStoreInAppAppStoreAppStoreInAppBillingData(value)) {
        return FxIdApplicationStoreInAppAppStoreAppStoreInAppBillingDataToJSON(value as FxIdApplicationStoreInAppAppStoreAppStoreInAppBillingData);
    }

    return {};
}

